import fetch from 'isomorphic-unfetch';

const fetchOptions = {
  credentials: 'include',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 NOTE: In order to save sent bytes from the client
 this method tries to run a fetch without uploading the
 query itself. If server and client versions differ
 the fetch reruns with query included
* */
const execQuery = (query, variables, key, main) => {
  const payload = {
    release: window.RELEASE,
    version: window.GRAPHQL_VERSION,
    variables,
    key,
    main,
    query: main ? undefined : query,
  };

  if (!main) {
    // If request is not succesfull, rerun the request with the query included
    return fetch(`/_internal/graphql`, {
      ...fetchOptions,
      body: JSON.stringify(payload),
    }).then(x => x.json());
  }

  // Make first request without query
  return fetch(
    `/_internal/graphql?release=${encodeURIComponent(payload.release)}${
      payload.version ? `&version=${payload.version}` : ''
    }&main=${main}&variables=${encodeURIComponent(JSON.stringify(variables))}`,
    {
      ...fetchOptions,
      method: 'GET',
      headers: {},
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json();
      }

      if (res.status === 418) {
        return location.reload();
      }

      // If request is not succesfull, rerun the request with the query included
      return fetch(`/_internal/graphql`, {
        ...fetchOptions,
        body: JSON.stringify({ ...payload, query }),
      }).then(x => x.json());
    })
    .catch(error => {
      const graphqlError = error.constructor(
        `GraphQL Fetch Error: ${error.message}`
      );

      if (error.stack) {
        graphqlError.stack = error.stack;
      }

      throw graphqlError;
    });
};

export default execQuery;
